import type { CSSProperties, ReactNode } from 'react';
import { DisplayScaleToggle } from './DisplayScaleToggle';

/**
 * Root of every redesign screen. Carries `.rd` (token scope — the invariant
 * that keeps flag-off production untouched) and `.rd-shell` (display-scale
 * zoom target). `onForest` switches to the dark-stage ring/quiet-button
 * variants for forest-background screens (currently only the 404 meta
 * screen — Review and Auth moved to the --stage-* roles with bd Vidi-2cf:
 * paper in Hearth, forest in Dusk).
 *
 * Every screen gets the persisted density chip for free, matching the
 * prototype's global affordance (blueprint §3 —
 * docs/redesign/DESIGN_BLUEPRINT.md). Route-level providers (toast, …) wrap
 * the screen from the gate — see RedesignProviders.
 */
export function Shell({
  children,
  onForest = false,
  className = '',
  style,
}: {
  children: ReactNode;
  onForest?: boolean;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rd rd-shell${onForest ? ' rd-on-forest' : ''}${className ? ` ${className}` : ''}`}
      style={style}
    >
      {children}
      <DisplayScaleToggle />
    </div>
  );
}
